export const MACHINES_IN_SERVICE_PERCENTAGE_GET =
  "MACHINES_IN_SERVICE_PERCENTAGE_GET";
export const TOP_PRODUCTS_IN_SERVICE_GET = "TOP_PRODUCTS_IN_SERVICE_GET";
export const DEMANDED_PRODUCTS_GET = "DEMANDED_PRODUCTS_GET";
export const PERCENTAGE_FILTER_ASC = "PERCENTAGE_FILTER_ASC";
export const PERCENTAGE_FILTER_DESC = "PERCENTAGE_FILTER_DESC";
export const DEMAND_FILTER_ASC = "DEMAND_FILTER_ASC";
export const DEMAND_FILTER_DESC = "DEMAND_FILTER_DESC";
